<template>
    <div class='main'>
       <div class='main-area'>
           <router-view></router-view>
       </div>
   </div>
</template>

<script setup>
   import { computed, ref, onMounted } from 'vue';
   import { useRouter } from 'vue-router';
   import store from '../store/index.js'

   const rounter = useRouter()

   const KYC_Available = computed(() => store.getters.KYC_Available)
   const user = computed(() => store.state.user)
   onMounted(() => {
       if (!user.value) {
           rounter.push('/login')
       }
       if (!KYC_Available.value) {
           store.dispatch('addNotification', { text: 'KYC Section is not available, contact support to get more info', type: 'error' })
           rounter.push('/')
       }
   })

</script>